import React from 'react';

import NavBar from '../components/NavBar';
import Blog from '../components/Blog';

const Post = () => {
    return (
        <div>
            <NavBar />
            <Blog />
        </div>
    )
}


export default Post